import { Link } from "react-router-dom";

function NotFound() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        textAlign: "center",
        padding: "2rem",
      }}
    >
      <h1
        style={{
          fontSize: "6rem",
          fontWeight: 600,
          color: "var(--color-accent)",
          marginBottom: "0.5rem",
          lineHeight: 1,
        }}
      >
        404
      </h1>
      <p
        style={{
          fontSize: "1.5rem",
          marginBottom: "0.5rem",
        }}
      >
        Page Not Found
      </p>
      <p
        style={{
          fontSize: "1rem",
          color: "var(--color-secondary)",
          marginBottom: "2rem",
        }}
      >
        The page you're looking for doesn't exist or has been moved.
      </p>
      <Link
        to="/"
        style={{
          padding: "0.7rem 2rem",
          borderRadius: "2rem",
          background: "linear-gradient(90deg, var(--color-secondary) 0%, var(--color-accent) 100%)",
          color: "#fff",
          textDecoration: "none",
          fontWeight: 600,
          border: "1px solid var(--color-accent)",
          transition: "all 0.3s ease",
        }}
      >
        Back to Home
      </Link>
    </div>
  );
}
export default NotFound;
